// ./src/ticketCost.ts
//
// ROADMAP #162, #282 — what `n` tickets of a type cost, as the server's engine states it. The public checkout and the box
// office both read it, so neither adds up a price of its own: the hold's total is the server's. Pure.

/** A type (or a type on one date) as a form reads its price. */
export interface TicketCostPriced {
  effectivePrice?: number | null;
  price?: number | null;
  costs?: number[] | null;
}

/**
 * What `n` tickets cost now: `costs[n − 1]`. Past what was sent (50 at most), the last cost plus the last ticket's price
 * for each one more; with no costs, the effective price × n.
 */
export const ticketsCost = (t: TicketCostPriced, n: number): number => {
  const count = Math.max(0, Math.floor(Number(n) || 0));
  const costs = Array.isArray(t.costs) ? t.costs.map(Number) : [];

  if (count === 0) {
    return 0;
  }
  if (costs.length === 0) {
    return Number(t.effectivePrice ?? t.price ?? 0) * count;
  }
  if (count <= costs.length) {
    return costs[count - 1];
  }

  const last = costs[costs.length - 1];
  const step = costs.length > 1 ? last - costs[costs.length - 2] : last;

  return Math.round((last + step * (count - costs.length)) * 100) / 100;
};
